// Códigos de error definidos por abakoo-api (RFC 7807 ProblemDetails)
export type ApiErrorCode =
  | 'VALIDATION_ERROR'
  | 'WRONG_CREDENTIALS'
  | 'ACCOUNT_LOCKED'
  | 'ACCOUNT_DISABLED'
  | 'EMAIL_NOT_VERIFIED'
  | 'PHONE_NOT_VERIFIED'
  | 'AUTHENTICATION_FAILED'
  | 'REGISTRATION_FAILED'
  | 'OTP_WRONG'
  | 'OTP_EXPIRED'
  | 'OTP_MAX_ATTEMPTS'
  | 'OTP_NOT_FOUND'
  | 'INVALID_RESET_TOKEN'
  | 'REFRESH_FAILED'
  | 'FEEDBACK_RATE_LIMIT'
  | 'UNKNOWN'

// Shape estándar de error de abakoo-api (RFC 7807)
export interface ProblemDetails {
  title: string
  status: number
  detail: string
  instance: string
  correlationId: string
  errorCode: ApiErrorCode
}

// Error tipado para todas las llamadas a la API.
// `data` almacena el body completo del error — útil para 403 con verificationToken.
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: ApiErrorCode,
    message: string,
    public readonly correlationId?: string,
    public readonly data?: Record<string, unknown>,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}
